/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Navbar_Nav_Use_CasesInputs */

const es_navbar_nav_use_cases = /** @type {(inputs: Navbar_Nav_Use_CasesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Casos de uso`)
};

const en_navbar_nav_use_cases = /** @type {(inputs: Navbar_Nav_Use_CasesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use Cases`)
};

/**
* | output |
* | --- |
* | "Use Cases" |
*
* @param {Navbar_Nav_Use_CasesInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const navbar_nav_use_cases = /** @type {((inputs?: Navbar_Nav_Use_CasesInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Navbar_Nav_Use_CasesInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_navbar_nav_use_cases(inputs)
	return en_navbar_nav_use_cases(inputs)
});
export { navbar_nav_use_cases as "navbar.nav_use_cases" }